// @flow

export { DisplayArgentineIVA } from './display-argentine-iva';
